import { AxiosResponse } from "axios";
import { errorToastMessage } from "../../utils/toast";
import { AppThunk } from "../store";
import http from "../../utils/http";
import {
  setAiSearchQuery,
  setFavouriteLoader,
  setResultLoader,
  setSearchParticipants,
  setSearchParticipantsCount,
  setSearchParticipantsLoader,
  setToggleFavourite,
  updateAiSearchResponse,
  updateQueryFavourite,
} from "../reducers/aiSearchSlice";
import { v4 as uuidv4 } from "uuid";
import { DateTime } from "luxon";
import { pageSize } from "../../Components/Common/styles/table";

export const sendAiQuery =
  (queryMessage: string): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(setResultLoader(true));
      const tempId = uuidv4();
      const body: any = {
        userInput: queryMessage,
        favourite: false,
      };
      dispatch(
        setAiSearchQuery({
          tempId,
          ...body,
        })
      );
      const res: AxiosResponse = await http.post(`/ai-query`, body);
      const resData = res?.data?.data;
      const data = {
        tempId,
        id: resData?.id,
        count: resData?.count?.count,
        response: resData?.results,
      };
      dispatch(updateAiSearchResponse(data));
      dispatch(setResultLoader(false));
    } catch (err) {
      errorToastMessage(err as Error);
      dispatch(setResultLoader(false));
    }
  };

export const addFavourites =
  (queryId: string, favourite: boolean): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(setFavouriteLoader(queryId));
      const res: AxiosResponse = await http.patch(
        `/ai-query/${queryId}/favourite`,
        {
          favourite,
        }
      );
      const resData = res?.data?.data;
      const data = {
        id: resData?.id,
        favourite: resData?.favourite,
      };
      dispatch(setToggleFavourite());
      dispatch(updateQueryFavourite(data));
      dispatch(setFavouriteLoader(""));
    } catch (err) {
      errorToastMessage(err as Error);
      dispatch(setFavouriteLoader(""));
    }
  };

export const fetchParticipantsListWithAI =
  (queryId: any, page: number): AppThunk =>
  async (dispatch, getState) => {
    try {
      dispatch(setSearchParticipantsLoader(true));
      let url: string = `/ai-query/execute/${queryId}?page=${
        page + 1
      }&size=${pageSize}`;

      const res: AxiosResponse = await http.get(url);
      const data = res?.data?.data;

      const newData = data?.results?.map((item: any) => ({
        // studyId: item?.study_id,
        email: item?.email,
        first_name: item?.first_name,
        last_name: item?.last_name,
        name:
          item?.first_name && item?.last_name
            ? `${item.first_name} ${item.last_name}`
            : item?.first_name || item?.last_name || "",
        createdAt:
          item?.created_at &&
          DateTime.fromISO(item?.created_at).toFormat("dd MMM yyyy"),
        participantId: item?.participant_id,
      }));

      dispatch(setSearchParticipants(newData));
      dispatch(setSearchParticipantsCount(Number(data?.count?.count)));
      dispatch(setSearchParticipantsLoader(false));
    } catch (err) {
      errorToastMessage(err as Error);
      dispatch(setSearchParticipantsLoader(false));
    }
  };

export const fetchParticipantsList =
  (page: number, filters: Record<string, any>): AppThunk =>
  async (dispatch, getState) => {
    try {
      dispatch(setSearchParticipantsLoader(true));
      let url: string = `/platform/participants?page=${
        page + 1
      }&size=${pageSize}`;
      Object.entries(filters).forEach(([key, value]) => {
        if (value) {
          url += `&${key}=${value}`;
        }
      });

      const res: AxiosResponse = await http.get(url);
      const data = res?.data?.data;

      const newData = data?.data?.map((item: any) => ({
        // studyId: item?.study_id,
        email: item?.email,
        first_name: item?.firstName,
        last_name: item?.lastName,
        name:
          item?.firstName && item?.lastName
            ? `${item.firstName} ${item.lastName}`
            : item?.firstName || item?.lastName || "",
        createdAt:
          item?.createdAt &&
          DateTime.fromISO(item?.createdAt).toFormat("dd MMM yyyy"),
        participantId: item?.id,
      }));

      dispatch(setSearchParticipants(newData));
      dispatch(setSearchParticipantsCount(Number(data?.count)));
      dispatch(setSearchParticipantsLoader(false));
    } catch (err) {
      errorToastMessage(err as Error);
      dispatch(setSearchParticipantsLoader(false));
    }
  };
